<template>
  <section
    id="question"
    class="co-bg-striped"
  >
    <div class="co-container-md mx-auto px-4 py-12 sm:py-[4.25rem]">
      <h2 class="co-heading-2-caption">
        こんな話が聞けます
      </h2>

      <!-- 経済産業省認定受講料最大70%OFF -->
      <img
        class="mx-auto mb-11 block sm:mb-16"
        src="~/assets/images/Te/TeCounseling/Question/70percentoff.svg"
        alt="経済産業省認定受講料最大70%OFF"
        width="303"
        height="96"
        loading="lazy"
      >

      <div class="te-question-area mt-12 flex flex-col justify-between sm:flex-row">
        <!-- 実際に副業、転職できるの？ -->
        <div class="te-question-wrap bg-white px-4 py-7 text-center md:px-8 lg:px-12">
          <div class="relative">
            <div class="te-question-title absolute hidden sm:block">
              <slot name="question1TitleImage">
                <img
                  class="mx-auto h-[32px] px-1 md:h-[43px]"
                  src="~/assets/images/Te/TeCounseling/Question/icon_briefcase.svg"
                  alt="実際に副業、転職できるの？"
                  height="43"
                  loading="lazy"
                >
              </slot>
            </div>
            <h3 class="co-display-10 mb-4 font-bold">
              <slot name="question1Title">
                実際に副業、転職できるの？
              </slot>
            </h3>
            <ul class="co-display-11 m-0 p-0 text-left">
              <li class="mb-2 flex items-center text-co-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question1List1">
                  本当に副業の仕事をもらえて稼げる？
                </slot>
              </li>
              <li class="mb-2 flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question1List2">
                  未経験でも転職できるの？
                </slot>
              </li>
              <li class="flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question1List3">
                  実績や卒業生の声を聞きたい
                </slot>
              </li>
            </ul>
          </div>
        </div>
        <!-- 受講料について -->
        <div class="te-question-wrap bg-white px-4 py-7 text-center md:px-8 lg:px-12">
          <div class="relative">
            <div class="te-question-title absolute hidden sm:block">
              <img
                class="mx-auto h-[32px] px-1 md:h-[43px]"
                src="~/assets/images/Te/TeCounseling/Question/icon-price.svg"
                alt="受講料について"
                height="43"
                loading="lazy"
              >
            </div>
            <h3 class="co-display-10 mb-4 font-bold">
              受講料について
            </h3>
            <ul class="co-display-11 m-0 p-0 text-left">
              <li class="mb-2 flex items-center text-co-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                リスキリング補助制度って何？
              </li>
              <li class="mb-2 flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                支払い方法って何があるの？
              </li>
              <li class="flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                受講料って元が取れる？
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="te-question-area mb-7 mt-4 flex flex-col justify-between sm:mb-8 sm:mt-12 sm:flex-row">
        <!-- プログラミング・Web制作について -->
        <div class="te-question-wrap bg-white px-4 py-7 text-center md:px-8 lg:px-12">
          <div class="relative">
            <div class="te-question-title absolute hidden sm:block">
              <img
                class="mx-auto h-[32px] px-1 md:h-[43px]"
                src="~/assets/images/Te/TeCounseling/Question/icon_desktop.svg"
                alt="プログラミング・Web制作について"
                height="43"
                loading="lazy"
              >
            </div>
            <h3 class="co-display-10 mb-4 font-bold">
              プログラミング・Web制作について
            </h3>
            <ul class="co-display-11 m-0 p-0 text-left">
              <li class="mb-2 flex items-center text-co-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                文系/未経験/年齢に関係なく学べる？
              </li>
              <li class="mb-2 flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                他のスキルより何がいいの？
              </li>
              <li class="flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                自分に合っているか診断して欲しい
              </li>
            </ul>
          </div>
        </div>
        <!-- 学習方法について -->
        <div class="te-question-wrap bg-white px-4 py-7 text-center md:px-8 lg:px-12">
          <div class="relative">
            <div class="te-question-title absolute hidden sm:block">
              <slot name="question4TitleImage">
                <img
                  class="mx-auto h-[32px] px-1 md:h-[43px]"
                  src="~/assets/images/Te/TeCounseling/Question/icon-keyboard.svg"
                  alt="学習方法について"
                  height="43"
                  loading="lazy"
                >
              </slot>
            </div>
            <h3 class="co-display-10 mb-4 font-bold">
              <slot name="question4Title">
                学習方法について
              </slot>
            </h3>
            <ul class="co-display-11 m-0 p-0 text-left">
              <li class="mb-2 flex items-center text-co-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question4List1">
                  どんな学び方をするの？
                </slot>
              </li>
              <li class="mb-2 flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question4List2">
                  メンターって必要なの？
                </slot>
              </li>
              <li class="flex items-center text-gray-600">
                <FontAwesomeIcon
                  :icon="faCheck"
                  class="fa-fw inline h-4 w-5 pr-2 text-co-primary-500"
                />
                <slot name="question4List3">
                  受講期間内に挫折せず学びきれる？
                </slot>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 割引特典 -->
      <div class="flex items-center justify-center">
        <img
          src="~/assets/images/Te/TeCounseling/Question/icon-cracker.svg"
          alt="クラッカー"
          width="34"
          height="36"
          loading="lazy"
        >
        <h4 class="co-display-10 mx-2 mb-0 text-center font-bold text-co-gray-600 sm:mx-3">
          <span class="te-marker-yellow-1">相談参加者限定の</span>
          <br class="block sm:hidden">
          <span class="te-marker-yellow-1">割引特典もご用意しております</span>
        </h4>
        <img
          src="~/assets/images/Te/TeCounseling/Question/icon-cracker.svg"
          alt="クラッカー"
          style="transform: scale(-1, 1)"
          width="34"
          height="36"
          loading="lazy"
        >
      </div>

      <template v-if="hasDiscountSlot">
        <slot name="discountText" />
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheck } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const slots = useSlots()

const hasDiscountSlot = computed(() => {
  return !!slots.discountText
})
</script>

<style scoped>
.te-question-area {
  gap: 1rem;
  @media (min-width: 996px) {
    gap: 2.5rem;
  }
}

.te-question-wrap {
  @media (min-width: 576px) {
    width: 50%;
  }
  .te-question-title {
    top: -2.25rem;
    right: 0;
    left: 0;
    @media (min-width: 768px) {
      top: -3.375rem;
    }
  }
}

/* マーカー */
.te-marker-yellow-1 {
  background: linear-gradient(transparent 70%, #ff3 0);
}
</style>
